// @flow
import BaseComponent from '../base_component/base_component'

export default class RoadshowRequest extends BaseComponent {
    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);
    
        const self = this
        $('body').on('click', '.request-roadshow-slots-toggle', function () {
            $(this).toggleClass('expanded')
            $(this).siblings('.request-roadshow-slots').toggleClass('expanded')
        })

        $('body').on('click', '.request-roadshow-slot', function () {
            self.requestRoadshowSlot($(this))
        })

        $('body').on('click', '.request-specific-roadshow-slot-active', function () {
            self.requestSpecificRoadshowSlot($(this))
        })
    }

    requestRoadshowSlot(button: JQuery) {
        button.removeClass('request-roadshow-slot')
        button.append(' <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>')

        let roadshowId = button.closest('.request-roadshow').data('roadshow-id')
        this.requestSlot(roadshowId, undefined).done( () => {
            button.removeClass('btn-primary')
            button.addClass('btn-success')
            button.html('Request Sent! <i class="fa fa-check" aria-hidden="true"></i>')
        })
    }

    requestSpecificRoadshowSlot(button: JQuery){
        button.removeClass('request-specific-roadshow-slot request-specific-roadshow-slot-active')
        let otherSlots = button.closest('.request-roadshow').find('.request-specific-roadshow-slot')
        otherSlots.addClass('disabled')
        otherSlots.removeClass('request-specific-roadshow-slot-active')
        button.append(' <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>')

        let roadshowId = button.closest('.request-roadshow').data('roadshow-id')
        let roadshowSlotId = button.data('roadshow-slot-id')
        this.requestSlot(roadshowId, roadshowSlotId).done( () => {
            button.addClass('btn-success')
            button.html('Request Sent! <i class="fa fa-check" aria-hidden="true"></i>')
        })
    }

    requestSlot(roadshowId: string, slotId: ?string) {
        let headers: {[string]: any} = {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        };
        return $.ajax({
            type: "POST",
            url: '/request_slot',
            data: JSON.stringify({
                'roadshow_id': roadshowId,
                'roadshow_slot_id': slotId
            }),
            dataType: 'json',
            contentType: 'application/json',
            headers: headers
        });
    }
}